import React from 'react';
import {HashRouter as Router, Routes, Route} from "react-router-dom";

import MyContextProvider from './components/login/MyContext';
import history from './components/login/history';

import Inicio from './components/views/inicio/Inicio';
import Crear_usuarios from './components/views/usuarios/Crear_usuarios';
import Ver_usuarios from './components/views/usuarios/Ver_usuarios';
import Proveedores from './components/views/compras/Proveedores';
import Clientes from './components/views/ventas/Clientes';
import Categorias from './components/views/inventarios/Categorias';
import Articulos from './components/views/inventarios/Articulos';

function App() {
  return (
    <MyContextProvider>
    <Router>
     <Inicio/>
     

      <Routes>
      <Route history={history}></Route>
      <Route path="/Crear_usuarios" element = {<Crear_usuarios />}></Route>
      <Route path="/Ver_usuarios" element = {<Ver_usuarios />}></Route>
      <Route path="/Proveedores" element = {<Proveedores />}></Route>
      <Route path="/Clientes" element = {<Clientes />}></Route>
      <Route path="/Categorias" element = {<Categorias />}></Route>
      <Route path="/Articulos" element = {<Articulos />}></Route>
        
   
      </Routes>


 </Router>
 </MyContextProvider>
  );
}

export default App;
